import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {DetailEntityShell, DetailHeroSummaryProvider, DetailSummaryPrintButton, DetailTabBar} from "../../../../../components/detailLayout";
import "../../../../../components/detailLayout/detailListLayout.css";
import "../../info/subPages/view/assetInfo.css";
import {skeleton} from "../../../../../redux/slice/apiSlice";
import DiligenceInfo from "./view/DiligenceInfo";
import {getDiligence} from "../../../../../api/asset/DiligenceService";
import {isMobile} from "../../../../../components/commonmethod/CommonMethod";
import {useDispatch, useSelector} from "react-redux";
import DiligenceAssets from "./view/DiligenceAssets";
import DiligenceReport from "./view/DiligenceReport";

function buildDiligenceAssetMeta(diligence) {
    const checked = (diligence.assets ?? []).filter((e) => e.checked === true).length;
    const total = (diligence.assets ?? []).length;
    return total > 0 ? `진행 ${checked}/${total}` : undefined;
}

function DiligenceView() {
    const navigate = useNavigate();
    const {id} = useParams();
    const location = useLocation();
    const isHandle = location.pathname.endsWith("/handle");
    const isReport = location.pathname.endsWith("/report");
    const [diligence, setDiligence] = useState();
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const dispatch = useDispatch();
    const refresh = useSelector((state) => state.status.refreshContent);
    const [tabs, setTabs] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "실사자산"},
        {clicked: false, name: "실사보고서"},
    ]);

    useEffect(() => {
        if (!id) return;

        setDiligence(undefined);
        setAssets([]);
        setHandler([]);

        dispatch(skeleton(true));
        getDiligence(id)
            .then((_) => {
                if (_.status === 200) {
                    setDiligence(_.data);
                    setHandler(_.data.handler);
                    const assetList = [];
                    _.data.assets.forEach((e) => assetList.push(e.asset));
                    setAssets(assetList);
                } else if (_.status === 201) {
                    if (_.data.errorCode === "AUTHORITY") {
                        alert(_.data.reason);
                        navigate(-1);
                    }
                }
            })
            .then(() => {
                if (isHandle) {
                    setTabs([
                        {clicked: false, name: "기본정보"},
                        {clicked: true, name: "실사자산"},
                        {clicked: false, name: "실사보고서"},
                    ]);
                }
                if (isReport) {
                    setTabs([
                        {clicked: false, name: "기본정보"},
                        {clicked: false, name: "실사자산"},
                        {clicked: true, name: "실사보고서"},
                    ]);
                }
                dispatch(skeleton(false));
            })
            .catch((error) => {
                console.error("An error occurred:", error);
                dispatch(skeleton(false));
            });
    }, [id, refresh, dispatch, navigate, isHandle, isReport]);

    const tabPathSuffixes = ["", "/handle", "/report"];

    const setTabsWithNavigate = (nextTabs) => {
        setTabs(nextTabs);
        const activeIdx = nextTabs.findIndex((tab) => tab.clicked);
        if (activeIdx < 0) return;
        const nextPath = `/diligence/${id}${tabPathSuffixes[activeIdx] ?? ""}`;
        if (location.pathname !== nextPath) {
            navigate(nextPath, {replace: true});
        }
    };

    if (!diligence) {
        return null;
    }

    const heroTitle = diligence.title || "실사상세";
    const heroMeta =
        [
            diligence.tickets && `번호 ${diligence.tickets}`,
            diligence.code?.name && `종류 ${diligence.code.name}`,
            diligence.contentStatus?.statusKorValue &&
                `상태 ${diligence.contentStatus.statusKorValue}`,
        ]
            .filter(Boolean)
            .join(" · ") || undefined;

    return (
        <div className={`common-container ${isMobile ? "" : "container-height"} border-l-gray detail-list-layout asset-detail-list-layout`}>
            <DetailHeroSummaryProvider>
                <DetailTabBar tabs={tabs} setTabs={setTabsWithNavigate} />

                {tabs[0].clicked && (
                    <DiligenceInfo diligence={diligence} setDiligence={setDiligence} />
                )}
                {tabs[1].clicked && (
                    <DetailEntityShell
                        key={`${id}-assets`}
                        className="diligence-assets-shell flex min-h-0 flex-1 flex-col"
                        title={heroTitle}
                        meta={buildDiligenceAssetMeta(diligence) ?? heroMeta}
                        canUpdate={false}
                        listUrl="/diligence"
                    >
                        <DiligenceAssets data={diligence} />
                    </DetailEntityShell>
                )}
                {tabs[2].clicked && (
                    <DetailEntityShell
                        key={`${id}-report`}
                        title={heroTitle}
                        meta={buildDiligenceAssetMeta(diligence) ?? heroMeta}
                        canUpdate={false}
                        listUrl="/diligence"
                        actions={<DetailSummaryPrintButton />}
                    >
                        <DiligenceReport
                            diligence={diligence}
                            setDiligence={setDiligence}
                            assets={assets}
                            setAssets={setAssets}
                            handler={handler}
                            setHandler={setHandler}
                        />
                    </DetailEntityShell>
                )}
            </DetailHeroSummaryProvider>
        </div>
    );
}

export default DiligenceView;
